export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1768719951887-539ce3752a05?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxjb21tZXJjaWFsJTIwY29uc3RydWN0aW9uJTIwc2l0ZXxlbnwwfHx8fDE3ODcxNzIwMTl8MA&ixlib=rb-4.1.0&q=85",
  upfits: "https://images.unsplash.com/photo-1772300164438-f73307d3b645?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxjb21tZXJjaWFsJTIwY29uc3RydWN0aW9uJTIwc2l0ZXxlbnwwfHx8fDE3ODcxNzIwMTl8MA&ixlib=rb-4.1.0&q=85",
  newBuilds: "https://images.unsplash.com/photo-1615406020658-6c4b805f1f30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb21tZXJjaWFsJTIwYnVpbGRpbmclMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg3MTcyMDE5fDA&ixlib=rb-4.1.0&q=85",
  process: "https://images.unsplash.com/photo-1768677903496-becc4be07258?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwY29uc3RydWN0aW9uJTIwc2l0ZXxlbnwwfHx8fDE3ODcxNzIwMTl8MA&ixlib=rb-4.1.0&q=85",
  charleston: "https://images.unsplash.com/photo-1677859533961-51147497c50f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxjaGFybGVzdG9uJTIwc291dGglMjBjYXJvbGluYSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODcxNzIwMTl8MA&ixlib=rb-4.1.0&q=85",
  texture: "https://images.pexels.com/photos/31024672/pexels-photo-31024672.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const services = [
  {
    slug: "commercial-upfits",
    num: "01",
    title: "Commercial Upfits",
    tag: "Office, retail & restaurant build-outs",
    img: IMAGES.upfits,
    intro:
      "Tenant upfits that get you open on time. We handle demolition, framing, MEP coordination, finishes, and final inspections — while your opening date stays fixed.",
    points: [
      "Office & corporate upfits",
      "Retail & storefront build-outs",
      "Restaurant & hospitality upfits",
      "Medical & professional suites",
      "Demolition & selective teardown",
      "MEP coordination & finishes",
    ],
  },
  {
    slug: "new-builds",
    num: "02",
    title: "New Builds",
    tag: "Ground-up commercial construction",
    img: IMAGES.newBuilds,
    intro:
      "Ground-up commercial construction, managed from site work to certificate of occupancy. One contractor, one schedule, one point of accountability.",
    points: [
      "Site work & foundations",
      "Structural framing & envelope",
      "Pre-engineered metal buildings",
      "Interior build-out",
      "Permitting & design coordination",
      "Turnover & closeout documentation",
    ],
  },
  {
    slug: "renovations",
    num: "03",
    title: "Renovations",
    tag: "Occupied-space & capital renovations",
    img: IMAGES.texture,
    intro:
      "Renovations in occupied buildings without the chaos. We phase the work around your tenants and operations so business keeps moving while the building improves.",
    points: [
      "Occupied renovations & phasing",
      "Facade & envelope upgrades",
      "Code & ADA compliance updates",
      "Systems replacement",
      "Common-area refreshes",
      "Capital improvement programs",
    ],
  },
  {
    slug: "general-commercial",
    num: "04",
    title: "General Commercial Construction",
    tag: "The work that doesn't fit a box",
    img: IMAGES.process,
    intro:
      "One call for the commercial work that doesn't fit a category — capital projects, pre-lease assessments, facility upgrades, and repairs done to a schedule.",
    points: [
      "Small capital projects",
      "Pre-lease & pre-purchase assessments",
      "Facility upgrades & repairs",
      "Punch & closeout work",
      "Building improvements",
      "Schedule-driven service work",
    ],
  },
];

export const formOptions = {
  projectTypes: [
    { value: "commercial-upfit", label: "Commercial Upfit" },
    { value: "new-build", label: "New Build" },
    { value: "renovation", label: "Renovation" },
    { value: "general-commercial", label: "General Commercial Work" },
    { value: "residential", label: "Residential" },
    { value: "other", label: "Something Else" },
  ],
  propertyTypes: [
    { value: "office", label: "Office" },
    { value: "retail", label: "Retail" },
    { value: "restaurant", label: "Restaurant / Food Service" },
    { value: "warehouse-industrial", label: "Warehouse / Industrial" },
    { value: "medical", label: "Medical / Professional" },
    { value: "hospitality", label: "Hospitality" },
    { value: "multifamily", label: "Multifamily / Mixed-Use" },
    { value: "other", label: "Other" },
  ],
  timelines: [
    { value: "asap", label: "As soon as possible" },
    { value: "1-3-months", label: "1–3 months" },
    { value: "3-6-months", label: "3–6 months" },
    { value: "6-plus-months", label: "6+ months out" },
    { value: "planning", label: "Still planning" },
  ],
  budgets: [
    { value: "under-50k", label: "Under $50k" },
    { value: "50k-150k", label: "$50k – $150k" },
    { value: "150k-500k", label: "$150k – $500k" },
    { value: "500k-1m", label: "$500k – $1M" },
    { value: "1m-plus", label: "$1M+" },
    { value: "not-sure", label: "Not sure yet" },
  ],
  visitTimings: [
    { value: "weekday-morning", label: "Weekday morning" },
    { value: "weekday-afternoon", label: "Weekday afternoon" },
    { value: "evening", label: "Evening" },
    { value: "weekend", label: "Weekend" },
    { value: "flexible", label: "Flexible — call me to schedule" },
  ],
};
